import React from "react";
import LazyLoad from "react-lazyload";
const sxs2026_committee = [
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN26-1.jpeg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN26-2.jpeg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN26-3.jpeg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN26-4.jpeg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN26-5.jpeg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN26-6.jpeg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN26-7.jpeg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN26-8.jpeg",
];

const backgroundGuides = [
  { name: "WTO", file: "WTO_MUN_26.pdf" },
  { name: "FC", file: "FC_MUN_26.pdf" },
  { name: "IPL", file: "IPL_MUN_2026.pdf" },
  { name: "UNSC", file: "UNSC_MUN_26.pdf" },
  { name: "AIPPM", file: "AIPPM_MUN_26.pdf" },
  { name: "LOK SABHA", file: "LOK_SABHA_MUN_26.pdf" },
  { name: "IP", file: "IP_MUN_26.pdf" },
  { name: "UNICEF-1", file: "UNICEF-1_MUN_26.pdf" },
  { name: "UNICEF-2", file: "UNICEF-2_MUN_26.pdf" },
];

function MUN2026() {
 const secretariat_data = [
  {
    id: 0,
    image: "/Images/Sanchita.jpeg",
    message: "Every expert was once a beginner, and every beginner has the potential to become extraordinary. I, Sanchita Goyal, a student of Class XII, am honoured to serve as the Secretary General of the 10th edition of SXMUN. My journey began as a first-time delegate in Class IX and has become an experience of learning, growth and leadership. I am committed to fostering inclusivity, intellectual curiosity, meaningful dialogue and diplomacy.",
    name: "Sanchita Goyal",
    designation: "Secretary General",
  },
  {
    id: 1,
    image: "/Images/Mayur.jpeg",
    message: "They may kill me, but they cannot kill my ideas. It is a privilege to serve as the Deputy Secretary General of SXMUN, marking its 10th edition under the theme UNUS MUNDUS - One World. Despite our differences, meaningful dialogue and diplomacy have the power to unite us. I look forward to fostering thoughtful debate, inspiring collaboration and creating an environment where every voice contributes to shaping a better world.",
    name: "Mayur Garg",
    designation: "Deputy Secretary General",
  },
  {
    id: 2,
    image: "/Images/Paviit.jpeg",
    message: "To strive, to seek, to find, and not to yield. I am Pavit Kaur Sidhu, a student leader, orator and scholar, currently serving as the Prime Minister of the St. Xavier's School Parliament for a second consecutive term. I am honoured to serve as the Director General of SXMUN 2026 and lead the landmark 10th Edition. My leadership is founded upon the conviction that integrity, vision and service confer lasting influence.",
    name: "Pavit Kaur Sidhu",
    designation: "Director General",
  },
  {
    id: 3,
    image: "/Images/Manya.jpeg",
    message: "Ten years ago, SXMUN began with a vision of creating a space where young minds could come together to debate, collaborate, and grow. For me, this journey has been deeply personal. From being a member of the Organising Committee in 2024 to serving in the Secretariat in 2025, and now serving as the Deputy Director General, I have watched this conference shape the people around me and myself. I hope SXMUN 2026 inspires every delegate just as it has inspired me.",
    name: "Manya Mangla",
    designation: "Deputy Director General",
  },
  {
    id: 4,
    image: "/Images/Jaynita.jpeg",
    message: "The future belongs to those who believe in the power of dialogue. I am Jaynita Sethi, a Grade 12 Commerce student at St. Xavier's School, Bathinda, and I am privileged to serve as the Charge D' Affaires for SXMUN 2026. Model United Nations is a place where diverse perspectives come together and future leaders learn diplomacy, cooperation and mutual respect. I look forward to welcoming every delegate to a conference that celebrates collaboration and new ideas.",
    name: "Jaynita Sethi",
    designation: "Charge D' Affaires",
  },
  {
    id: 5,
    image: "/Images/Deevansh.jpeg",
    message: "I am drawn to fault lines: the places where beliefs, systems, and thoughts are forced to prove their truth. I believe growth is the relentless search for our own truth. As Convener of this Model United Nations, I carry this conviction into the committee I help shape: not to hand delegates a settled truth, but to build the room where they are forced to find their own.",
    name: "Deevansh Brar",
    designation: "Convener",
  },
  {
    id: 6,
    image: "/Images/Vallprabha.jpeg",
    message: "My name is Vallprabha Puhanian. I am a dedicated student with a strong commitment to academics, leadership and personal growth. I have developed my public speaking, critical thinking, diplomacy and leadership skills through debates and MUN conferences. I am currently serving as the Co-Convener of the 10th Edition of St. Xavier's Model United Nations, contributing to the planning, coordination and successful execution of this flagship conference.",
    name: "Vallprabha Puhanian",
    designation: "Co-Convener",
  },
  {
    id: 7,
    image: "/Images/Vaanya.jpeg",
    message: "I, Vaanya Modgil, am honoured to serve as the Public Relations Head of the Secretariat. With a strong passion for communication, collaboration and diplomacy, I am committed to fostering meaningful connections and ensuring that every delegate, Executive Board member and participating institution feels welcomed and valued. I look forward to contributing to a conference that encourages thoughtful debate, mutual respect and the spirit of diplomacy.",
    name: "Vaanya Modgil",
    designation: "PR Head",
  },
  {
    id: 8,
    image: "/Images/Harleen.jpeg",
    message: "I am Harleen Kaur, and I am delighted to be a part of the Secretariat of Decennial - SXMUN '26. After being associated with the Organising Committee for the previous two editions, it feels rewarding to continue contributing to a conference that has taught me so much. Each edition has been a learning journey, and I look forward to helping create a conference that is engaging, memorable, and enjoyable for everyone.",
    name: "Harleen Kaur",
    designation: "Logistic Head",
  },
  {
    id: 9,
    image: "/Images/Hitesh.jpeg",
    message: "Diplomacy is the art of building bridges where others see walls. I am Hitesh Goyal, a student of Class X at St. Xavier's School, Bathinda, and I am honoured to serve as the Head of Delegate Affairs for the 10th Edition of SXMUN. My MUN journey has developed my appreciation for diplomacy, public speaking, negotiation and collaborative problem-solving. I remain committed to fostering meaningful dialogue and ensuring an enriching experience for every participant.",
    name: "Hitesh Goyal",
    designation: "Head of Delegate Affairs",
  },
  {
    id: 10,
    image: "/Images/Sarth.jpeg",
    message: "Let us therefore make every effort to do what leads to peace and mutual edification. It gives me immense pleasure to be part of the 10th Edition of Decennial - SXMUN. My MUN journey has helped me develop leadership, confidence and public speaking skills, while my interests in technology and graphic designing have strengthened my creative skills. As Technical Head, I aim to combine technology, creativity and precision to make this conference an experience beyond expectations.",
    name: "Sarth Goyal",
    designation: "Technical Head",
  },
  {
    id: 11,
    image: "/Images/Nishad.jpeg",
    message: "True leadership lies not in the spotlight, but in building the stage where others can shine. I am Nishad, a student of Class X at St. Xavier's School, Bathinda, and I am proud to serve as the Organising Committee Head for the landmark 10th Edition of SXMUN. My focus is the coordination, teamwork and planning that transform an ambitious vision into a flawless reality. I am committed to creating a seamless, welcoming and highly structured environment for every attendee.",
    name: "Nishad",
    designation: "Organising Committee Head",
  },
];

  return (
    <div className="col-12 row">
      <div className="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
        <article>
          <LazyLoad>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/manager.jpg"
              alt="St. Xavier’s School Bathinda"
              className="sxumn_2021_msg img-fluid"
            />
          </LazyLoad>
          <h3>Rev. Fr. Manager's Message</h3>
          <p>
            “O judgment! thou art fled to brutish beasts, and men have lost
            their reason.”
            <br />
            —William Shakespeare
            <br />
            (Julius Caesar)
          </p>
          <p>Dear Delegates, Faculty and Guests,</p>
          <p>
            The cutting satire drawn from Julius Caesar echoes through the
            international political aisles, raising the alarm against global
            diplomacy failures and their horrendous ramifications. The
            international map has been brutally torn into warzones and arbitrary
            political abductions, deadly blockades around the Pacific and Gulf
            nations have fractured the global order.
          </p>
          <p>
            As our global community wades through a welter of conflicting
            ideologies and crises of reason, the world looks to the educational
            sector to prepare the next generation with the robust ideals of
            ethical humanism. St. Xavier&apos;s school, Bathinda, solemnly
            upholds this responsibility and takes immense pride in launching the
            10th edition of SXMUN to inspire ethical international unison.This
            simulation is an entreaty to reclaim &apos;reason&apos; and
            &apos;judgment&apos;, entailing peace and harmony.
          </p>
          <p>
            To contain the savage impulse, a revolution guided by prudent
            leadership is called for. SXMUN invites young
            diplomats-in-the-making to devise a blueprint sketching a plan to
            combat complicated global crises, not with hostility, but with
            synergy and cohesive strategies. May the Muse of Judgment empower
            your deliberations, dialogues and debates with logic, moving the
            conclave towards impeccable peace.
          </p>
          <p>Warm regards,</p>
          <p>
            Rev. Fr. Eusebio Gomes
            <br />
            Manager
            <br />
            St. Xavier&apos;s School, Bathinda
          </p>
          <div className="clr"></div>
        </article>
        <div className="clr"></div>
      </div>
      <div className="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
        <article>
          <LazyLoad>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2023-principal.JPG"
              alt="St. Xavier’s School Bathinda"
              className="sxumn_2021_msg img-fluid"
            />
          </LazyLoad>
          <h3>Rev. Fr. Principal's Message</h3>
          <p>
            “How dull it is to pause, to make an end,
            <br />
            To rust unburnish&apos;d, not to shine in use!”
            <br />
            — Tennyson
            <br />
            (Julius Caesar)
          </p>
          <p>Dear Delegates, Faculty and Members of the Secretariat,</p>
          <p>
            While war is immoral to pacifists, it is non-moral to realists. The
            ongoing debates surrounding this issue often raise rhetoric against
            the moral relationships between nations, while discussions on the
            consequential economic burden on taxpayers frequently crash into
            mere conjecture. To answer and conclude this oblivious commotion,
            SXMUN Edition X propagates the theme of &apos;Unus Mundus&apos; –
            One World, One Dialogue and a Shared Future.
          </p>
          <p>
            As value education does not take place in isolation, it requires a
            contextual setting of the actual world we live in. The Xaverian
            spirit aligns seamlessly with the objective of building calibre
            based on working knowledge against formidable challenges. SXMUN–
            Edition X is all set to assemble the best intellectual talent in a
            simulation of an international consortium, aiming to uphold the
            value of shared interests while challenging the neo-colonial order.
          </p>
          <p>
            St. Xavier&apos;s academia takes pride in witnessing classrooms turn
            into the Security Council, wherein 15-year-olds, powered by
            cognitive abilities, demonstrate inspiring resilience. They ride the
            troughs and peaks of a long-drawn-out series of deliberations,
            culminating in the final drafting of resolutions. The decennial
            acknowledges the celebratory validation of incessant empirical
            discourse, clubbed with the meritorious administrative skills
            demonstrated by the Secretariat and Organizing Committee for ten
            glorious years.
          </p>
          <p>
            In an effort to replenish the ethical capital currently being eroded
            by acts of commission and omission in executing the United Nations
            charter and by the abuse of power afflicting the international
            order, SXMUN – Edition X, in compliance with the theories of
            consequentialism, deontology and virtue ethics, is set to unearth
            the complex relationship between morality and international
            diplomacy. The simulation augments the inevitable discussion on
            humanitarian intervention, exploring membership in international
            agencies like NATO and the justification of sanctions to expose
            suspicious, self-serving agendas.
          </p>
          <p>
            It is the Xaverian austere pursuit to expose the bloody business of
            conflict, where a severed carotid artery sends jitters down
            one&apos;s spine and where the aftermath leaves behind orphans,
            widows, the homeless and the starving, with epidemics filling graves
            faster than the war itself.
          </p>
          <p>Uphold the cause of humanity!</p>
          <p>Warm regards,</p>
          <p>
            Rev. Fr. Cidloy Furtado
            <br />
            Principal
            <br />
            St. Xavier&apos;s School, Bathinda
          </p>
          <div className="clr"></div>
        </article>
        <div className="clr"></div>
      </div>
      <div className="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
        <article>
          <h3>Message by Secretary General</h3>

          <p>
            “Individually, we are one drop.
            <br />
            Together, we are an ocean.” <b>— Ryunosuke Satoro</b>
          </p>

          <p>
            <b>Greetings everyone,</b>
          </p>

          <p>
            As we stand in a world that has endured suffering, distress and
            uncertainty, one often ponders, ‘WHAT COMES NEXT? WILL PEACE EVER
            RETURN?’ These questions still echo in the minds of youth who are
            uncertain and anxious about the coming future. Yet, in moments of
            fear and anxiety, hope persists—a hope to change, to rise and to
            act.
          </p>

          <p>
            This year, SXMUN&apos;s theme is not merely a theme but a call to
            rise and make a difference—DECENNIAL: DECADE OF DISCOURSE – UNUS
            MUNDUS. For ten years, SXMUN has stood as more than just a
            conference. It has served as a platform where perspectives are
            examined and constructive dialogue plays a crucial role in shaping
            the leaders of tomorrow. It marks a decade of diplomacy and
            discussion, where young minds have come together to address the
            pressing issues humanity is facing today.
          </p>

          <p>
            UNUS MUNDUS—a call for one world. A world that is connected despite
            its differences, a world with a shared vision and a world with a
            common cause. Let SXMUN be a platform for shared visions and ideas,
            where opinions transform into action.
          </p>

          <p>
            The wait is over. Let the vision of UNUS MUNDUS lead us towards
            unity.
          </p>

          <p>
            <strong>Warm Regards,</strong>
            <br />
            <br />
            Sanchita Goyal
            <br />
            Secretary General, SXMUN 2026
          </p>

          <div className="clr"></div>
        </article>

        <div className="clr"></div>
      </div>
      <div className="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
        <article>
          <h3>Message by Deputy Secretary-General</h3>
          <p>
            “The revolution is not an apple that falls when it is ripe.
            <br />
            You have to make it fall.” <b>— Che Guevara</b>
          </p>
          <p>
            <b>Dear Delegates,</b>
          </p>
          <p>
            It is with immense pride and honour that I welcome you to the 10th
            Edition of our Model United Nations Conference—a landmark
            celebration of a decade of diplomacy, dialogue and excellence.
          </p>
          <p>
            Over the past ten editions, this conference has grown into more than
            just an event; it has become a legacy that has empowered young
            leaders to think critically, speak confidently and lead with
            integrity. As we celebrate this remarkable journey, we also look
            ahead to the future that each one of you has the potential to shape.
          </p>
          <p>
            As you step into your committees, remember that true diplomacy is
            not about winning arguments but about building understanding. Speak
            with confidence, listen with respect and negotiate with purpose. Let
            every debate challenge your perspective, every resolution reflect
            your vision and every interaction strengthen your character.
          </p>
          <p>
            Whether this is your first MUN or your tenth, I encourage you to
            embrace every opportunity to learn, collaborate and grow. The
            experiences you gain here will extend far beyond the committee room.
          </p>
          <p>
            On behalf of the Secretariat, I warmly welcome you to this historic
            edition. May this conference inspire meaningful debate, lasting
            friendships and a shared commitment to creating a better future.
          </p>
          <p>
            <strong>Warm Regards,</strong>
            <br />
            Mayur Garg
            <br />
            Deputy Secretary-General
          </p>
          <div className="clr"></div>
        </article>

        <div className="clr"></div>
      </div>

      <div className="sxmun_img_sec_new row">
        <center>
          <h2>Committees and Agendas for SXMUN 2026 </h2>
        </center>
        {sxs2026_committee.map((item) => (
          <div
            className="col-12 col-sm-12 col-md-6 col-lg-4 mx-auto d-block"
            key={item}
          >
            <img src={item} alt="St. Xavier’s School Bathinda" />
            <div className="clr15"></div>
          </div>
        ))}
      </div>

      <div className="col-lg-12 col-md-12 col-sm-12 col-12 sx_msg_sec">
        <center>
          <h2>THE SECRETARIAT</h2>
        </center>

        {secretariat_data.sort(function(a,b){
          return a.id - b.id
        }).map((item) => (
          <article key={item.name}>
       
              <img
                src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public${item.image}`}
                alt={item.name}
                className="sxumn_2021_msg_secr"
              />
            
            <p>{item.message}</p>
            <p>
              {item.name}
              <br />- {item.designation}
            </p>
            <div className="clr"></div>
          </article>
        ))}

      </div>

      <h2>
        Background Guides <span></span>
      </h2>
      <div className="sxmun_sec_pdf">
        <div className="row">
          {backgroundGuides.map((item) => (
            <div
              className="col-6 col-sm-4 col-md-3 col-lg-3 fullwidth"
              key={item.name}
            >
              <article>
                <a
                  href={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/${item.file}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                    alt="St. Xavier’s School Bathinda"
                    className="img-fluid"
                  />
                  <h4>{item.name}</h4>
                </a>
              </article>
            </div>
          ))}
        </div>
      </div>

 <div className="clr20"></div>
       <div class="sxmun_img_sec_new row">
                <iframe
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/SXMUN-Newsletter26.pdf#toolbar=0&amp;navpanes=0"
                  width="100%"
                  height="800px"
                ></iframe>
              </div>
    </div>
  );
}

export default MUN2026;
